import { Container, AppBar, Toolbar, IconButton, Typography, Card, CardContent, SwipeableDrawer, TextField, Divider, Box, DialogTitle, DialogContent, DialogActions, InputAdornment } from '@mui/material';
import { ArrowBackOutlined, Cancel, CardMembershipOutlined, CheckCircle, Close, ContentCopy, CreditCardOutlined, PaymentsOutlined, PixOutlined } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { toHour, createNewTheme, descriptografarFinal, capitalize, getBandeira } from '../functions/utils';
import * as React from 'react';

import axios from 'axios';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import PropTypes from 'prop-types';
import Rating from '@mui/material/Rating';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import Snackbar from '@mui/material/Snackbar';
import LoadingComponent from '../components/LoadingComponent';

import '@fontsource/roboto/400.css';
import { BootstrapDialog } from '../components/utils';
import { ButtonMely } from '../components/DesignSystem/ButtonMely';
import CountdownTimer from '../components/DesignSystem/CountdownTimer';

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
}));

const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon color="error" style={{ fontSize: "36px", padding: "4px" }} />,
    label: 'Muito insatisfeito',
  },
  2: {
    icon: <SentimentDissatisfiedIcon color="error" style={{ fontSize: "36px", padding: "4px" }} />,
    label: 'Insatisfeito',
  },
  3: {
    icon: <SentimentSatisfiedIcon color="warning" style={{ fontSize: "36px", padding: "4px" }} />,
    label: 'Neutro',
  },
  4: {
    icon: <SentimentSatisfiedAltIcon color="success" style={{ fontSize: "36px", padding: "4px" }} />,
    label: 'Satisfeito',
  },
  5: {
    icon: <SentimentVerySatisfiedIcon color="success" style={{ fontSize: "36px", padding: "4px" }} />,
    label: 'Muito satisfeito',
  },
};

function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid #dcdbdb`,
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  backgroundColor: "#f2f2f2",
  padding: theme.spacing(2),
}));

function Pedido(props) {

  const state = useLocation().state;
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const { windows } = props;
  const page = state ? state.page : 'home';
  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [pedidos, setPedidos] = useState([]);
  const [nota, setNota] = useState(3);
  const [comentario, setComentario] = useState("");
  const [open, setOpen] = useState(false);
  const [openAjuda, setOpenAjuda] = useState(false);
  const [isMesa, setIsMesa] = useState(false);
  const [numeroMesa, setNumeroMesa] = useState(false);
  const [expanded, setExpanded] = useState('panel1');
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const [openAnalise, setOpenAnalise] = React.useState(false);
  const container = windows !== undefined ? () => windows().document.body : undefined;
  const navigate = useNavigate();

  const handleBack = () => {
    localStorage.removeItem('idp');
    localStorage.removeItem('idpT');
    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      navigate(`/?nm=${btoa(numeroMesa)}`, { replace: true, state: { page: page } })
    } else {
      navigate("/", { replace: true, state: { page: page } })
    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClickOpenAnalise = () => {
    setComentario("")
    setOpenAnalise(true);
  };
  const handleCloseAnalise = () => {
    setOpenAnalise(false);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
    setOpenAjuda(newOpen);
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleAvaliacao = (nota) => {
    setNota(nota)
  };

  const handleComentarioChange = (event) => {
    setComentario(event.target.value)
  };

  const handleAjuda = () => {
    setOpenAjuda(true)
  }

  const handleAvaliar = () => {
    handleOpenLoading();
    const avaliacao = `${nota} -- ${comentario}`

    const urlBase = localStorage.getItem('UBs');
    axios.post(`${urlBase}/avaliar.php`, {
      idpedidos: pedidos[0].idpedidos,
      nota: avaliacao
    })
      .then(response => {
        response = response.data
        if (!response) {
          handleSnack("Não foi possivel avaliar seu pedido, verifique sua conexão e tente novamente. (Código 0194)")
          return;
        }
        if (response.resposta === "falha") {
          handleSnack("Não foi possivel avaliar seu pedido, verifique sua conexão e tente novamente. (Código 0198)")
          return;
        }
        if (response.resposta === "sucesso") {
          setOpen(false)
          handleSnack("Seu pedido foi avaliado com sucesso.")
          return;
        }
        handleSnack("Não foi possivel avaliar seu pedido, verifique sua conexão e tente novamente. (Código 0206)")
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente. (Código 0208)"));

  };

  const handleEnviarAnalise = () => {

    if (comentario.length < 50) {
      handleSnack("Descreva a situação com pelo menos 50 caracteres para ser avaliada pela nossa equipe.")
      return
    }
    let motivo = "Não definido.";

    if (expanded === "fraude") {
      motivo = "Suspeita de fraude ou cobrança indevida."
    }
    else if (expanded === "pagamento") {
      motivo = "Problemas com pagamento."
    }

    handleOpenLoading();

    axios.post(`https://gerenciador.mely.online/api/suporte-analise.php`, {
      nome: localStorage.getItem('nmUsr'),
      email: localStorage.getItem('emUsr'),
      telefone: localStorage.getItem('tUsr'),
      idestabelecimento: localStorage.getItem('Md'),
      estabelecimento: localStorage.getItem('Mn'),
      motivo: motivo,
      descricao: comentario,
      pedidopagarme: pedidos[0].retornopagarme,
      idpedido: pedidos[0].idpedidos,
    })
      .then(response => {
        response = response.data
        if (!response) {
          handleSnack("Não foi possivel enviar sua análise, verifique sua conexão e tente novamente. (Código 0259)")
          return;
        }
        if (response.resposta === "falha") {
          handleSnack("Não foi possivel enviar sua análise, verifique sua conexão e tente novamente. (Código 0263)")
          return;
        }
        if (response.resposta === "sucesso") {
          setOpenAnalise(false)
          handleSnack("Sua análise foi enviada com sucesso e logo será revisada pela nossa equipe.")
          return;
        }
        handleSnack("Não foi possivel enviar sua análise, verifique sua conexão e tente novamente. (Código 0271)")
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente. (Código 0273)"));
  };

  const handleCancelar = () => {
    let isReembolso = false
    if ((pedidos[0].formapagamento.includes("{") || pedidos[0].formapagamento === "PIX") && pedidos[0].statuspagarme === "paid") {
      isReembolso = true
    }
    const jsonPagarme = JSON.parse(pedidos[0].retornopagarme)

    handleOpenLoading();
    const urlBase = localStorage.getItem('UBs');
    axios.post(`${urlBase}/cancelar-pedido.php`, {
      isReembolso: isReembolso,
      idPagarme: jsonPagarme?.charges[0]?.id,
      idpedido: pedidos[0].idpedidos,
    })
      .then(response => {
        response = response.data
        console.log(response)
        if (!response) {
          handleSnack("Não foi possivel cancelar o seu pedido, verifique sua conexão e tente novamente. (Código 0307)")
          return;
        }
        if (response.resposta === "falha") {
          handleSnack("Não foi possivel cancelar o seu pedido, verifique sua conexão e tente novamente. (Código 0311)")
          return;
        }
        if (response.resposta === "sucesso") {
          setOpenAnalise(false)
          pedidos[0].status = "C"
          handleSnack(`Seu pedido foi cancelado com sucesso.${isReembolso ? " O reembolso será processado em até 5 dias úteis." : ""}`)
          return;
        }
        handleSnack("Não foi possivel cancelar o seu pedido, verifique sua conexão e tente novamente. (Código 0319)")
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente. (Código 0321)"));
  };

  useEffect(() => {
    handleOpenLoading();

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`;

    if (colorPrimary) {
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }

    const numeroMesa = localStorage.getItem('nM');
    if (numeroMesa) {
      setIsMesa(true);
      setNumeroMesa(numeroMesa)
    }
    const idp = localStorage.getItem('idp');
    if (idp) {
      getPedido(id);
      return
    }
    const idpT = localStorage.getItem('idpT');
    if (idpT) {
      getPedidoAvulso(id);
      return
    }
    handleBack()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPedidoAvulso = (idp) => {
    const urlBase = localStorage.getItem('UBs');
    axios.get(`${urlBase}/pedido.php?timestamp=${idp}`)
      .then(response => {
        if (response.data) {
          // console.log(JSON.parse(atob(pedidos[0].detalhes)))
          setPedidos(response.data)
          if (response.data[0].avaliacao) {
            const arrAvaliacao = response.data[0].avaliacao.split(" -- ")
            setNota(parseInt(arrAvaliacao[0]))
            setComentario(arrAvaliacao[1])
          }
          handleCloseLoading();
          return
        }
        console.log("AQUI")
        handleSnack("Número do pedido não foi encontrado. Por favor verifique e tente novamente.");
        handleOpenLoading();
        setTimeout(handleBack, 3000);
      })
      .catch(error => {
        console.log(error)
        handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente. (Código 0265)")
      });
  }

  const getPedido = (idp) => {
    const urlBase = localStorage.getItem('UBs');
    axios.get(`${urlBase}/pedido.php?idpedidos=${idp}`)
      .then(response => {
        if (response.data) {
          setPedidos(response.data)
          if (response.data[0].avaliacao) {
            const arrAvaliacao = response.data[0].avaliacao.split(" -- ")
            setNota(parseInt(arrAvaliacao[0]))
            setComentario(arrAvaliacao[1])
          }
          handleCloseLoading();
          return
        }
        handleSnack("Número do pedido não foi encontrado. Por favor verifique e tente novamente.");
        setTimeout(handleBack, 3000);
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente. (Código 0280)"));
  }

  const getIconForPaymentMethod = (paymentMethod, retornopagarme) => {

    if (paymentMethod === "PIX" && retornopagarme) {
      const json = JSON.parse(retornopagarme);
      if (getExpirationTime(json.charges[0].last_transaction?.expires_at) <= 0 || json.status === "paid") {
        return <PixOutlined style={{ color: '#464545' }} />;
      }
      return null;
    }

    if (paymentMethod.includes("{")) {
      return <img alt="forma-pagamento" src={`${localStorage.getItem('UBs').replaceAll("/api", "")}/imagens/${getBandeira(getNumber(pedidos[0].formapagamento))}.png`} style={{ width: 40 }} />
    }

    if (!paymentMethod) {
      return <PaymentsOutlined style={{ color: '#464545' }} />;
    }
    if (paymentMethod.includes("Dinheiro")) {
      return <PaymentsOutlined style={{ color: '#464545' }} />;
    }
    switch (paymentMethod) {
      case 'PIX':
        return <PixOutlined style={{ color: '#464545' }} />;
      case 'MASTERCARD':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'VISA':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'ELO':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'AMERICAN EXPRESS':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'BANRI COMPRAS':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'VERDCARD':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'HIPERCARD':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'DINNERS CLUB':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'AURA':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'CREDICARD':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'SOROCRED':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'PAN':
        return <CreditCardOutlined style={{ color: '#464545' }} />;
      case 'ALELO':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'SODEXO':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'TICKET':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'VR BENEFICIOS':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'FLASH':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'GREENCARD':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'VB':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'IFOOD ALIMENTAÇÃO':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'LINK DE PAGAMENTO':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      case 'PONTOS':
        return <CardMembershipOutlined style={{ color: '#464545' }} />;
      default:
        return <PaymentsOutlined style={{ color: '#464545' }} />;
    }
  };

  const getExpirationTime = (expiration) => {
    const expirationTime = new Date(expiration).getTime();
    const now = new Date().getTime();
    const diff = expirationTime - now;
    return diff;
  }

  const getFormaPagamento = (formapagamento, retornopagarme) => {
    if (formapagamento.includes("{")) {
      const jsonPagamento = JSON.parse(formapagamento);
      return `${capitalize(jsonPagamento.BD_CT)} ●●●● ${descriptografarFinal(jsonPagamento.NR_CT)}`
    }
    if (formapagamento === "PIX" && retornopagarme) {
      const json = JSON.parse(retornopagarme);
      if (json.status === "paid") {
        return <Box sx={{ textAlign: "center" }}>
          <Typography style={{ fontSize: "12px", color: "#999", textAlign: getExpirationTime(json.charges[0].last_transaction?.expires_at) > 0 ? "center" : "left" }}>
            <strong>Pix QR Code</strong>
            <br />
            Pago pelo APP
          </Typography>
        </Box>
      } else {
        return <Box sx={{ textAlign: "center" }}>
          <Typography style={{ fontSize: "12px", color: "#999", textAlign: getExpirationTime(json.charges[0].last_transaction?.expires_at) > 0 ? "center" : "left" }}>
            {getExpirationTime(json.charges[0].last_transaction?.expires_at) > 0 ?
              <>
                <CountdownTimer expiresAt={json.charges[0].last_transaction?.expires_at} />
                <strong>Pix QR Code</strong>
                <br />
                Aproxime a câmera do seu dispositivo para escanear o QR Code, ou clique no botão abaixo para copiar!
                <Box alt="qrcode" component="img" src={json.charges[0].last_transaction.qr_code_url} style={{ width: "200px", height: "200px" }} />
                <TextField
                  fullWidth
                  value={json.charges[0].last_transaction.qr_code}
                  variant="outlined"
                  sx={{ mt: 2 }}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => handleCopyQR(json.charges[0].last_transaction.qr_code)}>
                          <ContentCopy />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </>
              :
              <>
                <strong>Pix QR Code</strong>
                <br />
                O QR Code pagamento expirou, por favor entre em contato com o estabelecimento para cancelamento do pedido.
              </>
            }
          </Typography>
        </Box>
      }
    }
    return <>{formapagamento}{formapagamento === "PIX" && <ButtonMely fullWidth={false} variant="contained" onClick={() => handleCopy()} style={{ float: "right", marginTop: -8, marginBottom: -15, textTransform: "none", paddingTop: 4, paddingBottom: 4 }}> Copiar Chave PIX</ButtonMely>}</>
  }

  const getNumber = (formapagamento) => {
    if (formapagamento.includes("{")) {
      const jsonPagamento = JSON.parse(formapagamento);
      return jsonPagamento.NR_CT
    }
    return <></>
  }

  const getPedidoStatus = (pedido) => {
    let statusPedido = "", horaPedido = ""
    if (pedido.status === "F") {
      pedido.endereco === "Retirada" ? statusPedido = "Retirado" : statusPedido = "Entregue"
    } else {
      if (pedido.status === "C") {
        statusPedido = "Pedido cancelado"
      } else {
        statusPedido = "Pedido realizado"
      }
    }

    if (!pedido.demaishoras) {
      return <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ borderRadius: "8px" }}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography style={{ fontSize: "16px", fontWeight: "bold", color: "#1B1B1B" }}>
            {statusPedido === "Pedido cancelado" && <Cancel style={{ color: "tomato", fontSize: "16px", marginBottom: "-2px", marginLeft: "-8px" }} />}
            {statusPedido !== "Pedido cancelado" && <CheckCircle style={{ color: "#33540E", fontSize: "16px", marginBottom: "-2px", marginLeft: "-8px" }} />}
            &nbsp;&nbsp; {statusPedido}
          </Typography>
          <Typography style={{ fontSize: "10px", marginLeft: "auto", color: "#999999", paddingTop: "5px", paddingRight: "10px" }}>{toHour(pedido.data)}</Typography>
        </AccordionSummary>
      </Accordion>;
    }

    const arrHoras = pedido.demaishoras.split(",");
    if (arrHoras[2]) {
      horaPedido = toHour(arrHoras[2])
    }

    if (arrHoras[1] && !arrHoras[2]) {
      statusPedido = pedido.endereco === "Retirada" ? "Aguardando retirada" : "Saiu para entrega"
      horaPedido = toHour(arrHoras[1])
    }

    if (arrHoras[0] && !arrHoras[1] && !arrHoras[2]) {
      statusPedido = "Preparando"
      horaPedido = toHour(arrHoras[0])
    }

    if (pedido.status === "C") {
      statusPedido = "Pedido cancelado"
    }

    return <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ borderRadius: "8px" }}>

      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
        <Typography style={{ fontSize: "16px", fontWeight: "bold", color: "#1B1B1B" }}>
          {statusPedido === "Pedido cancelado" && <Cancel style={{ color: "tomato", fontSize: "16px", marginBottom: "-2px", marginLeft: "-8px" }} />}
          {statusPedido !== "Pedido cancelado" && <CheckCircle style={{ color: "#33540E", fontSize: "16px", marginBottom: "-2px", marginLeft: "-8px" }} />}
          &nbsp;&nbsp; {statusPedido}
        </Typography>
        <Typography style={{ fontSize: "10px", marginLeft: "auto", color: "#999999", paddingTop: "5px", paddingRight: "10px" }}>{horaPedido}</Typography>
      </AccordionSummary>
      <AccordionDetails style={{ borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px" }}>

        {arrHoras[1] && arrHoras[2] && (
          <>
            <Typography style={{ display: "flex", alignContent: "center" }}>
              <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>
                <CheckCircle style={{ color: "#33540E", fontSize: "16px", marginBottom: "-2px" }} /> &nbsp;&nbsp; {pedido.endereco === "Retirada" ? "Aguardando retirada" : "Saiu para entrega"}
              </Typography>
              <Typography style={{ fontSize: "10px", marginLeft: "auto", color: "#999999", paddingTop: "4px" }}>
                {toHour(arrHoras[1])}
              </Typography>
            </Typography>

            <Box style={{ height: 35 }} />
          </>
        )}

        {arrHoras[0] && arrHoras[1] && (
          <>
            <Typography style={{ display: "flex", alignContent: "center" }}>
              <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>
                <CheckCircle style={{ color: "#33540E", fontSize: "16px", marginBottom: "-2px" }} /> &nbsp;&nbsp; Preparando
              </Typography>
              <Typography style={{ fontSize: "10px", marginLeft: "auto", color: "#999999", paddingTop: "4px" }}>
                {toHour(arrHoras[0])}
              </Typography>
            </Typography>

            <Box style={{ height: 35 }} />
          </>
        )}

        <Typography style={{ display: "flex", alignContent: "center" }}>
          <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>
            <CheckCircle style={{ color: "#33540E", fontSize: "16px", marginBottom: "-2px" }} /> &nbsp;&nbsp; Pedido realizado
          </Typography>
          <Typography style={{ fontSize: "10px", marginLeft: "auto", color: "#999999", paddingTop: "4px" }}>
            {toHour(pedido.data)}
          </Typography>
        </Typography>
      </AccordionDetails>
    </Accordion>
  };

  const getTab = (pedido) => {
    if (!pedido) {
      return ""
    }
    if (pedido.status === "F") {
      return `Pedido concluído: ${pedido.data}`
    } else {
      return `Pedido: ${pedido.data}`
    }
  };

  const handleCopyQR = async (qrcode) => {
    try {
      await navigator.clipboard.writeText(qrcode);
      handleSnack("Chave PIX copiada com sucesso.")
    } catch (err) {
      handleSnack("Não foi possivel copiar a chave PIX")
    }
  };

  const handleCopy = () => {
    const urlBase = localStorage.getItem('UBs');
    axios.post(`${urlBase}/formas-pagamento.php`, {
      idestabelecimentos: 1
    })
      .then(response => {
        const formas = response.data[0].formas_pagamento;
        const pagamentosArray = formas.split("--");
        handleCopy2(pagamentosArray[3]);
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente. (Código 0448)"));
  }

  const handleCopy2 = async (chavePix) => {
    try {
      await navigator.clipboard.writeText(chavePix);
      handleSnack("Chave PIX copiada com sucesso.")
    } catch (err) {
      handleSnack("Não foi possivel copiar a chave PIX")
    }
  };

  const mensagemCancelamento = () => {

    if (pedidos[0].status === "C") {
      return "Pedido já cancelado"
    }

    const timeDelivery = localStorage.getItem('tD');
    let arrTime = timeDelivery.split("(")
    arrTime = arrTime[1].replaceAll(")", "").replaceAll("min", "").split(" - ")
    const finalTime = parseInt(arrTime[1]);
    const agora = Date.now();
    const pedidoEmSegundos = pedidos[0].data * 1000;

    const tempoDecorrido = agora - pedidoEmSegundos;

    const cincoMinutos = 5 * 60 * 1000;
    const tempoFinal = finalTime + 10 * 60 * 1000;

    if (tempoDecorrido <= cincoMinutos) {
      return "Cancelamento automático permitido (até 5 minutos)";
    }

    if (pedidos[0].status === "R" && tempoDecorrido > cincoMinutos) {
      return "Falta de atualização no pedido (em mais de 5 minutos)";
    }

    if (tempoDecorrido > tempoFinal) {
      const tempoAtraso = finalTime + 10
      return "Pedido atrasado (mais de " + tempoAtraso + " minutos)";
    }

    return "Cancelamento sujeito a análise ou regras manuais";
  };

  const permiteCancelamento = (tipo) => {
    if (pedidos[0].status === "C" || pedidos[0].status === "F") {
      return false
    }

    const timeDelivery = localStorage.getItem('tD');
    let arrTime = timeDelivery.split("(")
    arrTime = arrTime[1].replaceAll(")", "").replaceAll("min", "").split(" - ")
    const finalTime = parseInt(arrTime[1]);
    const agora = Date.now();
    const pedidoEmSegundos = pedidos[0].data * 1000;
    const tempoDecorrido = agora - pedidoEmSegundos;

    const cincoMinutos = 5 * 60 * 1000;
    const tempoFinal = finalTime + 10 * 60 * 1000;

    if (tipo === 0 && tempoDecorrido <= cincoMinutos) {
      return true;
    }

    if (tipo === 1 && pedidos[0].status === "R" && tempoDecorrido > cincoMinutos) {
      return true;
    }

    if (tipo === 1 && tempoDecorrido > tempoFinal) {
      return true;
    }

    return false;
  };

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>
        <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
          <Toolbar>
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#FFF" }} onClick={handleBack}>
              <ArrowBackOutlined />
            </IconButton>
            {getTab(pedidos[0])}
          </Toolbar>
        </AppBar>

        <LoadingComponent open={loading} />

        <Snackbar
          open={openSnack}
          autoHideDuration={10000}
          onClose={handleClose}
          message={msgSnack}
          action={<Close fontSize="small" onClick={handleClose} />}
        />

        <Box style={{ height: 83 }} />

        <SwipeableDrawer container={container} anchor="bottom" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)} disableSwipeToOpen={true} ModalProps={{ keepMounted: true, }} >

          <Box style={{ backgroundColor: "#D6D6D6", height: "4px", width: "32px", borderRadius: "100px", margin: "15px auto" }} />

          <Typography style={{ fontSize: "14px", textAlign: "center", color: "#464444", fontWeight: "bold" }}>
            Avalie seu pedido abaixo.
          </Typography>

          <Box style={{ height: 12 }} />

          <Typography style={{ textAlign: "center" }}>
            <StyledRating
              name="highlight-selected-only"
              value={nota}
              IconContainerComponent={IconContainer}
              getLabelText={(value) => customIcons[value].label}
              onChange={(value) => handleAvaliacao(value.target.value)}
              highlightSelectedOnly
            />
          </Typography>

          <Typography style={{ fontSize: "14px", textAlign: "center", color: "#464444", fontWeight: "bold" }}>
            Que tal comentar em que podemos melhorar.
          </Typography>
          <Box style={{ height: 16 }} />
          <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
            <TextField
              id="outlined-multiline-static"
              label="Comentários"
              multiline
              rows={4}
              value={comentario}
              onChange={handleComentarioChange}
              style={{ width: "100%" }}
            />
          </Typography>

          <Box sx={{ p: "20px" }}>
            <ButtonMely onClick={handleAvaliar}>Avaliar</ButtonMely>
          </Box>
        </SwipeableDrawer>


        {pedidos[0] && (
          <>
            {getPedidoStatus(pedidos[0])}

            <Box style={{ height: 30 }} />

            <Typography style={{ color: "#1B1B1B", fontSize: "16px", fontWeight: "bold" }}>
              {!isMesa && (
                <>
                  {pedidos[0].endereco === "Retirada" ? "Opção de entrega:" : "Entregar em:"}
                  <Box style={{ height: 10 }} />
                  <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                    <CardHeader
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      title={pedidos[0].endereco === "Retirada" ? "Retirada" : "Casa"}
                      titleTypographyProps={{ fontSize: "12px", fontWeight: "500", color: "#999" }}
                      subheader={pedidos[0].endereco === "Retirada" ? "-" : pedidos[0].endereco}
                      subheaderTypographyProps={{ fontSize: "14px", fontWeight: "bold", color: "#1B1B1B" }}
                    />
                  </Card>
                  <Box style={{ height: 12 }} />
                </>
              )}
              Detalhes do pedido
              <Box style={{ height: 10 }} />

              {isMesa && (
                <>
                  <b style={{ color: "#888", fontSize: "13px" }}>Número da mesa: {numeroMesa}</b>
                  <Box style={{ height: 12 }} />
                </>
              )}

              {!isMesa && (
                <>
                  <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                    <CardHeader
                      title="Taxa de entrega"
                      titleTypographyProps={{ fontSize: "12px", fontWeight: "500", color: "#999" }}
                      subheader={(pedidos[0].taxa !== "" && pedidos[0].taxa !== "Grátis" && pedidos[0].taxa !== "combinar") ? `R$ ${pedidos[0].taxa}` : `-`}
                      subheaderTypographyProps={{ fontSize: "12px", fontWeight: "bold", color: "#1B1B1B" }}
                    />
                  </Card>
                  <Box style={{ height: 10 }} />
                </>
              )}

              {!isMesa && (
                <>
                  <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                    <CardHeader
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      avatar={getIconForPaymentMethod(pedidos[0].formapagamento, pedidos[0].retornopagarme)}
                      title={pedidos[0].formapagamento.includes("{") ? "Crédito" : getFormaPagamento(pedidos[0].formapagamento, pedidos[0].retornopagarme)}
                      titleTypographyProps={{ fontSize: "12px", fontWeight: "600", color: "#1B1B1B" }}
                      subheader={pedidos[0].formapagamento.includes("{") ? getFormaPagamento(pedidos[0].formapagamento, pedidos[0].retornopagarme) : ""}
                      subheaderTypographyProps={{ fontSize: "12px", fontWeight: "600", color: "rgba(0,0,0,.45)" }}
                    />

                  </Card>
                  <Box style={{ height: 10 }} />
                </>
              )}

              <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                <CardContent>
                  <Typography style={{ fontSize: "12px", color: "#999" }}>
                    N° {pedidos[0].data}
                  </Typography>
                  <Box style={{ height: 10 }} />
                  <Typography>
                    {(JSON.parse(atob(pedidos[0].detalhes))).map((detalhes) => (
                      <Typography style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", color: "#464444" }}>
                        {detalhes.quantidade}x {detalhes.nome} <b>R$ {detalhes.valorTotal}</b>
                      </Typography>
                    ))}
                  </Typography>
                </CardContent>

                {pedidos[0].status === "F" && (
                  <CardActions disableSpacing>
                    <Typography style={{ textAlign: "center", width: "100%" }}>
                      <ButtonMely variant="text" onClick={() => setOpen(true)}>Avaliar</ButtonMely>
                    </Typography>
                  </CardActions>
                )}


              </Card>
              <Box style={{ height: 10 }} />
              <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                <CardHeader
                  title="Valor total"
                  titleTypographyProps={{ fontSize: "12px", fontWeight: "500", color: "#999" }}
                  subheader={`R$ ${pedidos[0].valor}`}
                  subheaderTypographyProps={{ fontSize: "12px", fontWeight: "bold", color: "#1B1B1B" }}
                />
              </Card>
            </Typography>

            <Box style={{ height: 20 }} />

            <ButtonMely color="error" size="large" onClick={handleAjuda}>Precisa de Ajuda?</ButtonMely>

          </>
        )}

        {pedidos[0] &&
          <SwipeableDrawer container={container} anchor="bottom" open={openAjuda} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)} disableSwipeToOpen={true} ModalProps={{ keepMounted: true, }} >
            <Box style={{ backgroundColor: "#D6D6D6", height: "4px", width: "32px", borderRadius: "100px", margin: "15px auto" }} />

            <Typography style={{ fontSize: "14px", textAlign: "center", color: "#464444", fontWeight: "bold" }}>
              Ajuda com o pedido
            </Typography>

            <Box style={{ height: 10 }} />

            <Box style={{ textAlign: "left", paddingLeft: 22 }}>
              <b style={{ background: "tomato", color: "white", fontWeight: 500, fontSize: 11, padding: 4, borderRadius: 4 }}>{mensagemCancelamento()}</b>
            </Box>

            <Box style={{ height: 10 }} />

            <Accordion expanded={expanded === 'errado'} onChange={handleChange('errado')} style={{ border: "none" }}>
              <AccordionSummary aria-controls="ajuda" id="errado">
                <Typography component="span">Cliquei errado (Pedido feito por engano)</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Você pode cancelar automaticamente até 5 minutos após o pedido, com reembolso total — caso ele tenha sido pago pelo app.</Typography>
                <Box style={{ textAlign: "center", paddingTop: 12 }}>
                  <ButtonMely disabled={!permiteCancelamento(0)} onClick={handleCancelar}>Cancelar pedido</ButtonMely>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Divider style={{ margin: 16, marginTop: 0, marginBottom: 0 }} />

            <Accordion expanded={expanded === 'demorando'} onChange={handleChange('demorando')} style={{ border: "none" }}>
              <AccordionSummary aria-controls="ajuda" id="demorando">
                <Typography component="span">Está demorando muito</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Se o pedido estiver atrasado, ou o restaurante ainda não tiver iniciado o preparo, você pode cancelar com reembolso total — caso ele tenha sido pago pelo app.</Typography>
                <Box style={{ textAlign: "center", paddingTop: 12 }}>
                  <ButtonMely
                    // disabled={!permiteCancelamento(1)} 
                    disabled
                    onClick={handleCancelar}>Cancelar pedido</ButtonMely>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Divider style={{ margin: 16, marginTop: 0, marginBottom: 0 }} />

            <Accordion expanded={expanded === 'fechado'} onChange={handleChange('fechado')} style={{ border: "none" }}>
              <AccordionSummary aria-controls="ajuda" id="fechado">
                <Typography component="span">Restaurante não atende ou está fechado</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Se o restaurante estiver fechado ou não atender seu pedido, você pode cancelar com reembolso total — caso ele tenha sido pago pelo app.</Typography>
                <Box style={{ textAlign: "center", paddingTop: 12 }}>
                  <ButtonMely
                    // disabled={!permiteCancelamento(1)} 
                    disabled
                    onClick={handleCancelar}>Cancelar pedido</ButtonMely>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Divider style={{ margin: 16, marginTop: 0, marginBottom: 0 }} />

            <Accordion expanded={expanded === 'pagamento'} onChange={handleChange('pagamento')} style={{ border: "none" }}>
              <AccordionSummary aria-controls="ajuda" id="pagamento">
                <Typography component="span">Problemas com pagamento</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Se o pagamento falhou ou foi cobrado duas vezes, nossa equipe analisará e fará o reembolso total ou parcial.
                  (Válido apenas para pedidos feitos pelo app. A análise pode levar de 1 a 5 dias úteis.)</Typography>
                <Box style={{ textAlign: "center", paddingTop: 12 }}>
                  <ButtonMely disabled={!pedidos[0].formapagamento.includes("{")} onClick={handleClickOpenAnalise}>Solicitar análise</ButtonMely>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Divider style={{ margin: 16, marginTop: 0, marginBottom: 0 }} />

            <Accordion expanded={expanded === 'modificar'} onChange={handleChange('modificar')} style={{ border: "none" }}>
              <AccordionSummary aria-controls="ajuda" id="modificar">
                <Typography component="span">Quero modificar meu pedido</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Você pode falar diretamente com o restaurante pelo botão <b>"Falar com estabelecimento"</b>. Se preferir, cancele e refaça o pedido —
                  dentro dos 5 minutos iniciais, o cancelamento é automático e com reembolso total (para pedidos pagos pelo app).</Typography>
              </AccordionDetails>
            </Accordion>

            <Divider style={{ margin: 16, marginTop: 0, marginBottom: 0 }} />

            <Accordion expanded={expanded === 'incorreto'} onChange={handleChange('incorreto')} style={{ border: "none" }}>
              <AccordionSummary aria-controls="ajuda" id="incorreto">
                <Typography component="span">Pedido já foi entregue, mas está incorreto ou com problema</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Neste caso, entre em contato com o restaurante pelo botão <b>"Falar com estabelecimento"</b> para verificar.
                  <br /> Caso não obtenha retorno você pode solicitar uma análise do nosso suporte.</Typography>
              </AccordionDetails>
            </Accordion>

            <Divider style={{ margin: 16, marginTop: 0, marginBottom: 0 }} />

            <Accordion expanded={expanded === 'fraude'} onChange={handleChange('fraude')} style={{ border: "none" }}>
              <AccordionSummary aria-controls="ajuda" id="fraude">
                <Typography component="span">Suspeita de fraude ou cobrança indevida</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Encaminharemos para análise imediata. Se confirmado, o reembolso será total. (Apenas para pedidos realizados pelo app, o tempo de análise entre 1 e 5 dias)</Typography>
                <Box style={{ textAlign: "center", paddingTop: 12 }}>
                  <ButtonMely disabled={!pedidos[0].formapagamento.includes("{")} onClick={handleClickOpenAnalise}>Solicitar análise</ButtonMely>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Box style={{ height: 12 }} />

            <Box style={{ padding: 16 }}>
              <ButtonMely variant="contained" href={localStorage.getItem('UMs')} target="_blank">Falar com estabelecimento</ButtonMely>
            </Box>
          </SwipeableDrawer>
        }

        <BootstrapDialog
          onClose={handleCloseAnalise}
          aria-labelledby="customized-dialog-title"
          open={openAnalise}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Solicitar análise
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseAnalise}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <Close />
          </IconButton>
          <DialogContent dividers>
            <Typography style={{ fontSize: 13 }}>
              Motivo:
              {expanded === "fraude" && " Suspeita de fraude ou cobrança indevida."}
              {expanded === "pagamento" && " Problemas com pagamento."}
            </Typography>
            <Divider style={{ marginTop: 5, marginBottom: 5 }} />
            <Typography style={{ fontSize: 13 }}>
              Descreva brevemente a sua situação para nossa equipe realizar a revisão.
              <Box style={{ height: 12 }} />
              <TextField
                id="outlined-multiline-static"
                label="Descreva o seu relato"
                multiline
                rows={4}
                value={comentario}
                onChange={handleComentarioChange}
                style={{ width: "100%" }}
              />
            </Typography>

          </DialogContent>
          <DialogActions>
            <ButtonMely variant="contained" autoFocus onClick={handleEnviarAnalise}>
              Enviar
            </ButtonMely>
          </DialogActions>
        </BootstrapDialog>

        <Box style={{ height: 100 }} />

      </Container>
    </ThemeProvider>
  );
}

export default Pedido;